var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152.156,
    height: 163.54,
    viewBox: "0 0 152.156 163.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Drop_image",
    "data-name": "Drop image",
    transform: "translate(-741.138 -358.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image",
    transform: "translate(725.705 406.498) rotate(-30)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(0.001 14.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(0 16.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M26.04,52.966A15.6,15.6,0,0,1,11.282,42.337l-.146-.479a15.2,15.2,0,0,1-.721-4.517V8.932L.306,42.674A9.463,9.463,0,0,0,6.94,54.154L71.371,71.409a9.556,9.556,0,0,0,2.4.308,9.29,9.29,0,0,0,9-6.813l3.754-11.938Z",
    transform: "translate(-0.001 -8.932)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M15.334,21.667A8.334,8.334,0,1,0,7,13.334,8.342,8.342,0,0,0,15.334,21.667Z",
    transform: "translate(22.165 -5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M76.918,2h-62.5A10.431,10.431,0,0,0,4,12.417V58.251A10.431,10.431,0,0,0,14.417,68.668h62.5A10.431,10.431,0,0,0,87.335,58.251V12.417A10.431,10.431,0,0,0,76.918,2Zm-62.5,8.334h62.5A2.084,2.084,0,0,1,79,12.417V42L65.839,26.638a7.463,7.463,0,0,0-5.588-2.563A7.286,7.286,0,0,0,54.685,26.7L39.209,45.28l-5.042-5.029a7.313,7.313,0,0,0-10.334,0l-11.5,11.5V12.417a2.084,2.084,0,0,1,2.083-2.083Z",
    transform: "translate(12.665)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Curved_arrow",
    "data-name": "Curved arrow",
    d: "M14.05,50.5a3.9,3.9,0,0,1-2.762-1.146L1.722,39.807a5.863,5.863,0,0,1,0-8.3l9.566-9.547a3.915,3.915,0,0,1,6.68,2.766V33.7A28.158,28.158,0,0,0,46.094,5.578V2.453a1.953,1.953,0,1,1,3.906,0V5.578a31.824,31.824,0,0,1-9.382,22.651,31.823,31.823,0,0,1-22.65,9.382A3.911,3.911,0,0,1,14.062,33.7V24.727h0l-.01,0,0,0L4.481,34.273a1.956,1.956,0,0,0,0,2.77l9.566,9.547,0,0,.01,0V44.447a1.953,1.953,0,0,1,3.907,0v2.141A3.919,3.919,0,0,1,14.05,50.5Zm0,0",
    transform: "translate(824.56 496.52) rotate(-60)",
    fill: "rgba(0,0,0,0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropImage);
export default __webpack_public_path__ + "static/media/drop_image.e20657915cf5617e2bdc7e49991e0af2.svg";
export { ForwardRef as ReactComponent };